exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dataTables_wrapper .dataTables_info,.dataTables_wrapper .dataTables_paginate{display:none}table.dataTable.no-footer,table.dataTable thead th{border-bottom:none}table.dataTable thead td,table.dataTable thead th{padding:10px}td.dataTables_empty{display:none}", ""]);

// exports
